import { Routes, Route, Navigate } from "react-router-dom";

// routers
import { CountryRouter } from "./CountryRouter";

import AnnouncementRouter from "./AnnouncementRouter";
import AccountRouter from "./AccountRouter";
import ContractorRouter from "./ContractorRouter";
import DriverRouter from "./DriverRouter";
import AccountListRouter from "./AccountListRouter";
import AuthorizationRouter from "./AuthorizationRouter";
import BlogRouter from "./BlogRouter";
// import CRMClientRouter from "./CRMClientRouter";
import NoteRouter from "./NoteRouter";
import EntityRouter from "./EntityRouter";
import FeedbackRouter from "./FeedbackRouter";
import GlobalListRouter from "./GlobalListRouter";
import EntityListRouter from "./EntityListRouter";
import EmailTemplateRouter from "./EmailTemplateRouter";
import NotificationRouter from "./NotificationRouter";
import TaskRouter from "./TaskRouter";
import TeamRouter from "./TeamRouter";
import TicketRouter from "./TicketRouter";
import UserRouter from "./UserRouter";
import WarehouseRouter from "./WarehouseRouter";
import VehicleRouter from "./VehicleRouter";
import VehicleMaintenanceRouter from "./VehicleMaintenanceRouter";
import CustomerRouter from "./CustomerRouter";
import ShipmentFulfillmentDocumentRouter from "./ShipmentFulfillmentDocumentRouter";
import ShipmentRouter from "./ShipmentRouter";
import TranshipmentRouter from "./TranshipmentRouter";
import CrossDockingRouter from "./CrossDockingRouter";
import WarehouseAllocationRouter from "./WarehouseAllocationRouter";
import CollectionRouter from "./CollectionRouter";
import DeliveryRouter from "./DeliveryRouter";
import CommunicationRouter from "./CommunicationRouter";
import ComplianceRouter from "./ComplianceRouter";
import RealTimeTrackingRouter from "./RealTimeTrackingRouter";
import IncidentReportRouter from "./IncidentReportRouter";
import DeconsolidationRouter from "./DeconsolidationRouter";
import FreeloadingRouter from "./FreeloadingRouter";
// pages & components
import { NotFoundScreen } from "screens/NotFoundScreen";
import DataIntegrationRouter from "./DataIntegrationRouter";
import BranchRouter from "./BranchRouter";
import BranchAssignmentRouter from "./BranchAssignmentRouter";
import RegionRouter from "./LocationRoutes/RegionRouter";
import DistrictRoute from "./LocationRoutes/DistrictRouter";
import MunicipalityRoute from "./LocationRoutes/MunicipalityRouter";
import VendorRouter from "./canUsers/VendorRouter";
import VendorProfileRouter from "./VendorProfileRouter";
import SettingRouter from "./SettingRouter";
import CustomerUserRouter from "./CustomerUserRouter";
import ContractorUserRouter from "./ContractorUserRouter";
import ShipmentLoadingRouter from "./ShipmentLoadingRouter";
import ShipmentUnLoadingRouter from "./ShipmentUnLoadingRouter";
import RouteShipmentRouter from "./RouteShipmentRouter";
import LegRouter from "./LegRouter";
import ConsolidationRouter from "./ConsolidationRouter";
import WarehousingRouter from "./WarehousingRouter";
import SendOutRouter from "./SendOutRouter";
import SendOutCollectionRouter from "./SendOutCollectionRouter";
import ReportRouter from "./ReportRouter";
import VehicleFuelRouter from "./VehicleFuelRouter";

import PaymentAccountRouter from "./Payments/PaymentAccountRouter";
import AccountLedgerRouter from "./Payments/AccountLedgerRouter";
import PrepaymentRouter from "./Payments/PrepaymentRouter";
import AdjustmentRouter from "./Payments/AdjustmentRouter";
import DeliveryCollectionRouter from "./Payments/deliveryCollectionRouter";
import CocCollectionRouter from "./Payments/CocCollectionRouter";
import CodTransferRouter from "./Payments/CodTransferRouter";
import ManifestoRouter from "./ManifestoRouter";
import MerchantRouter from "./MerchantRouter";
import TripRouter from "./TripRouter";
import ShipmentActionRouter from "./ShipmentActionRouter";

import SmsProviderRouter from "./SmsProviderRouter";
import SmsTemplateRouter from "./SmsTemplateRouter";
import SmsIntegrationRouter from "./SmsIntegrationRouter";
import SmsLogListRouter from "./SmsLogRouter";
import PaymentIntegrationRouter from "./PaymentIntegrationRouter";
import CRMDashboardScreen from "screens/App/CRM/Dashboard/CRMDashboardScreen";
import LocalTransportRouter from "./LocalTransportRouter";
import LocalTransportRuleRouter from "./LocalTransportRuleRouter";
import VendorLeadRouter from "./VendorLeadRouter";
import VendorQuotationRouter from "./VendorQuotationRouter";
import VendorQuotationExcelRouter from "./VendorQuotationExcelRouter";
import GeneralLedgerRouter from "./GeneralLedgerRouter";
import EBillProviderRouter from "./EBillProviderRouter";
import VehicleListingRouter from "./VehicleListingRouter";
import ShipmentRefundRouter from "./Payments/ShipmentRefundRouter";
import LoadTransferRouter from "./LoadTransferRouter";
import VehicleHiringEntryRouter from "./VehicleHiringEntryRouter";
import BranchTallyRouter from "./BranchTallyRouter";



export const CRMRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="announcement/*" element={<AnnouncementRouter />} />
      <Route path="account/*" element={<AccountRouter />} />
      <Route path="account-list/*" element={<AccountListRouter />} />
      <Route path="authorization/*" element={<AuthorizationRouter />} />
      <Route path="blog/*" element={<BlogRouter />} />
      <Route path="branch/*" element={<BranchRouter />} />
      <Route path="branchAssignment/*" element={<BranchAssignmentRouter />} />
      <Route path="country/*" element={<CountryRouter />} />
      <Route path="customerProfile/*" element={<CustomerRouter />} />
      {/* <Route path="customer/*" element={<CustomerRouter />} /> */}
      <Route path="customerUser/*" element={<CustomerUserRouter />} />
      <Route path="contractorUser/*" element={<ContractorUserRouter />} />

      <Route path="vendor/*" element={<VendorRouter />} />
      <Route path="note-list/*" element={<NoteRouter />} />
      <Route path="action-list/*" element={<ShipmentActionRouter />} />
      <Route path="vendor-profile/*" element={<VendorProfileRouter />} />

      <Route path="dashboard" element={<CRMDashboardScreen />} />
      <Route path="email-template/*" element={<EmailTemplateRouter />} />
      <Route path="entity/*" element={<EntityRouter />} />
      <Route path="entity-list/*" element={<EntityListRouter />} />
      <Route path="contractor/*" element={<ContractorRouter />} />
      <Route path="feedback/*" element={<FeedbackRouter />} />
      <Route path="global-list/*" element={<GlobalListRouter />} />
      <Route path="notification/*" element={<NotificationRouter />} />
      <Route path="region/*" element={<RegionRouter />} />
      <Route path="district/*" element={<DistrictRoute />} />
      <Route path="municipality/*" element={<MunicipalityRoute />} />
      <Route path="task/*" element={<TaskRouter />} />
      <Route path="team/*" element={<TeamRouter />} />
      <Route path="ticket/*" element={<TicketRouter />} />
      <Route path="user/*" element={<UserRouter />} />
      <Route path="*" element={<NotFoundScreen />} />
      <Route path="warehouse/*" element={<WarehouseRouter />} />
      <Route path="driver/*" element={<DriverRouter />} />
      <Route path="vehicle/*" element={<VehicleRouter />} />
      <Route path="dataIntegration/*" element={<DataIntegrationRouter />} />

      <Route path="incident-report/*" element={<IncidentReportRouter />} />
      <Route path="vehicle-hiring-entry/*" element={<VehicleHiringEntryRouter />} />
      <Route path="delivery/*" element={<DeliveryRouter />} />

      <Route
        path="vehicle-maintenance/*"
        element={<VehicleMaintenanceRouter />}
      />
      <Route
        path="branch-tally/*"
        element={<BranchTallyRouter />}
      />
      <Route path="merchant/*" element={<MerchantRouter />} />
      <Route path="merchant/*" element={<MerchantRouter />} />
      <Route path="trip/*" element={<TripRouter />} />
      <Route path="route-shipment/*" element={<RouteShipmentRouter />} />
      <Route
        path="warehouse-allocation/*"
        element={<WarehouseAllocationRouter />}
      />
      <Route path="collection/*" element={<CollectionRouter />} />

      <Route path="shipment/*" element={<ShipmentRouter />} />
      <Route
        path="collection-document/*"
        element={<ShipmentFulfillmentDocumentRouter />}
      />
      <Route path="transshipment/*" element={<TranshipmentRouter />} />
      <Route path="shipment-loading/*" element={<ShipmentLoadingRouter />} />
      <Route path="shipment-manifesto/*" element={<ManifestoRouter />} />

      <Route path="freeloading/*" element={<FreeloadingRouter />} />
      <Route
        path="shipment-unLoading/*"
        element={<ShipmentUnLoadingRouter />}
      />
      <Route path="sms-provider/*" element={<SmsProviderRouter />} />
      <Route
        path="paymentIntegration/*"
        element={<PaymentIntegrationRouter />}
      />
      <Route path="sms-templates/*" element={<SmsTemplateRouter />} />
      <Route path="sms-integrations/*" element={<SmsIntegrationRouter />} />

      <Route path="cross-docking/*" element={<CrossDockingRouter />} />
      <Route path="communication/*" element={<CommunicationRouter />} />
      <Route path="compliance/*" element={<ComplianceRouter />} />
      <Route path="realtime-tracking/*" element={<RealTimeTrackingRouter />} />
      <Route path="setting/*" element={<SettingRouter />} />
      <Route path="leg/*" element={<LegRouter />} />
      <Route path="consolidation/*" element={<ConsolidationRouter />} />
      <Route path="deconsolidation/*" element={<DeconsolidationRouter />} />
      <Route path="warehousing/*" element={<WarehousingRouter />} />
      <Route path="sendOut/*" element={<SendOutRouter />} />
      <Route path="sendOutCollection/*" element={<SendOutCollectionRouter />} />
      <Route path="reports/*" element={<ReportRouter />} />
      <Route path="vehicle-fuel/*" element={<VehicleFuelRouter />} />
      <Route path="local-transport/*" element={<LocalTransportRouter />} />
      <Route path="load-transfer/*" element={<LoadTransferRouter />} />
      <Route
        path="local-transport-rule/*"
        element={<LocalTransportRuleRouter />}
      />
      <Route path="vendor-lead/*" element={<VendorLeadRouter />} />
      <Route path="vehicle-listing/*" element={<VehicleListingRouter />} />
      <Route path="vendor-quotation/*" element={<VendorQuotationRouter />} />
      <Route path="vendor-quotation-excel/*" element={<VendorQuotationExcelRouter />} />

      {/* Payment Routes */}
      <Route path="ebill-provider/*" element={<EBillProviderRouter />} />
      <Route path="general-ledger/*" element={<GeneralLedgerRouter />} />
      <Route path="payment-account/*" element={<PaymentAccountRouter />} />
      <Route path="account-ledger/*" element={<AccountLedgerRouter />} />
      <Route path="coc-collection/*" element={<CocCollectionRouter />} />
      <Route path="shipment-refund/*" element={<ShipmentRefundRouter />} />
      <Route
        path="delivery-collection/*"
        element={<DeliveryCollectionRouter />}
      />
      <Route path="prepayment/*" element={<PrepaymentRouter />} />
      <Route path="adjustment/*" element={<AdjustmentRouter />} />
      <Route path="cod-transfer/*" element={<CodTransferRouter />} />
      <Route path="sms-log/*" element={<SmsLogListRouter />} />
    </Routes>
  );
};

export default CRMRouter;
